import { useEffect, useRef } from 'react';
import { GtmPageViewEventType } from 'types/gtm';
import { useGtmContext } from 'utils/Gtm/context/GtmProvider';
import { gtmSafePushEvent } from 'utils/Gtm/Gtm';

export const useGtmStaticPageView = (event: GtmPageViewEventType): void => {
    const wasViewedRef = useRef(false);
    const { setDidPageViewRun } = useGtmContext();

    useEffect(() => {
        if (event._isLoaded && !wasViewedRef.current) {
            wasViewedRef.current = true;
            gtmSafePushEvent(event);
            setDidPageViewRun(true);
        }
    }, [event]);
};
